export enum DepositRelevoTableMode {
  SUCCESS = 'SUCCESS',
  CONFIRM = 'CONFIRM',
  ERROR = 'ERROR',
}
